import { BackgroundColorHotkey, BackgroundColorOptions } from './options'

export * from './plugin/with-background-color'
export * from './plugin/background-color-editor'
export type { BackgroundColorOptions, BackgroundColorHotkey }
